import { render, staticRenderFns } from "./device-parameters.vue?vue&type=template&id=7b7dc2be&scoped=true&"
import script from "./device-parameters.vue?vue&type=script&lang=js&"
export * from "./device-parameters.vue?vue&type=script&lang=js&"
import style0 from "./device-parameters.vue?vue&type=style&index=0&id=7b7dc2be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7dc2be",
  null
  
)

export default component.exports